import React, { ReactNode } from 'react';
import Floater from 'react-floater-fixed';

import { ColorPalette } from 'theme/colors';

import { StyledFloater, TooltipBaloon, InfoCircleIcon, Content, StyledFloaterRounded } from './styles';

export interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
  event?: 'click' | 'hover' | undefined;
  whiteColor?: boolean;
  isActive?: boolean;
}

const TooltipContent = ({ content, whiteColor }) => (
  <TooltipBaloon 
    style={{
    ...(whiteColor && {
      backgroundImage: 'linear-gradient(73deg, white 0%, white 100%)',
      color: 'white',
    }),
  }}>
    <InfoCircleIcon />
    <Content style={{ color: !whiteColor ? ColorPalette.HEX.White : ColorPalette.HEX.OuterSpace }}>{content}</Content>
  </TooltipBaloon>
);

const Tooltip = ({ children, content, event, whiteColor }: TooltipProps) => (
  <StyledFloater>
    <Floater
      event={event}
      styles={{ arrow: { color: whiteColor ? ColorPalette.HEX.White : ColorPalette.HEX.OuterSpace } }}
      component={() => <TooltipContent content={content} whiteColor={whiteColor} />}
    >
      {children}
    </Floater>
  </StyledFloater>
);

const RoudendTooltip = ({ children, content, event, whiteColor, isActive }: TooltipProps) => (
  <StyledFloaterRounded activeColor={!isActive}>
    <StyledFloater>
      <Floater
        event={event}
        styles={{ arrow: { color: whiteColor ? ColorPalette.HEX.White : ColorPalette.HEX.OuterSpace } }}
        component={() => <TooltipContent content={content} whiteColor={whiteColor} />}
      >
        {children}
      </Floater>
    </StyledFloater>
  </StyledFloaterRounded>
);
export { RoudendTooltip };

export default Tooltip;
